import React, { useState, useEffect, useCallback } from "react";
import './../../App.css';
import './Transactions.css';
import axios from 'axios';
import {token, domain} from './../Security';
import {CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import loadingSpinner from './../../assets/loading.gif';
import {useTable, useSortBy} from 'react-table';
// icon
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';

function MobileHistory({user, userAccess, isHideSideMenu}) {
    var uploadTimeEntriesHeader = [
        "Employee Id",
        "Employee",
        "Device",
        "Date Of Registration",
        "Last Logged In",
    ]
    var uploadTimeEntriesaccessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "registeredDevice",
        "dateOfRegistration",
        "lastLogIn",
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [daysRange, setDaysRange] = useState(15)
    const [tempDaysRange, setTempDaysRange] = useState(15)

    const generate = () => {
        if(daysRange !== tempDaysRange){
            setDaysRange(tempDaysRange) 
        }
    }

    const apiUrl =  domain + "/api/MobileHistory";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl + `/employee/${0}/days/${daysRange}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            setDateTimeRecordData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl, daysRange]);

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                    || f.employeePersonalInformationEmployeeId.toLowerCase().includes(lowercaseValue)
                );

        setDateTimeRecordData(res);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TransactionInfo shadow-xl">
                        <div className="transaction-header">
                        <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Mobile History"}</span>
                        </div>
                            <h3>Mobile History</h3>
                        </div>
                        <div className="transaction-body">
                            <>
                                <div className="mainte-body-top row">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e) => handleFilter(e.target.value), 
                                                                    "Search by employee", 
                                                                    SearchIcon)}
                                </div>

                                <div className="flex items-end gap-2 py-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Days Range
                                        </label>
                                        <input
                                        type="number"
                                        min="1"
                                        value={tempDaysRange}
                                        onChange={(e) => setTempDaysRange(Number(e.target.value))}
                                        className="w-32 rounded-md px-3 py-2 text-xs text-gray-600"
                                        style={{border:"1px solid #80808080"}}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => generate()}
                                        className="cursor-pointer rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                                    >
                                        Generate
                                    </button>
                                </div>

                                <div className="transaction-table container">
                                    <CreateTable
                                        dataList={dateTimeRecordData}
                                        dataHeader={uploadTimeEntriesHeader}
                                        dataAccessor={uploadTimeEntriesaccessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        // fetchDataById={fetchDataById}

                                        // setSelected={setSelected}
                                        // isSelectAll={isSelectAll}
                                        // setIsSelectAll={setIsSelectAll}
                                        // activeRowIds={activeRowIds}
                                        // setActiveRowIds={setActiveRowIds}
                                    />
                                    {dateTimeRecordData.length > 0 ? (
                                        <div></div>
                                    )
                                    :
                                    (
                                        <div>
                                        {loading ? (
                                            <div
                                                style={{
                                                position: "fixed",
                                                top: "0",
                                                left: "0",
                                                width: "100vw",
                                                height: "100vh",
                                                zIndex: "2000",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                                backgroundColor: "#ffffff59",
                                                }}
                                            >
                                                <img src={loadingSpinner} alt="Loading..." />
                                            </div>
                                        ) : (
                                                <div> {/*<p>No records to display</p>*/}</div>
                                            )
                                        }
                                        </div>
                                    )}
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "5000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], approveHandleClick, disapproveHandleClick, currentPage, setCurrentPage,
}) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    /* const handleRowClick = (rowData) => {
        setSelected(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    }; */

    return (
        <>
            <div>
                <div className='scrollable-table'>
                    <table {...getTableProps()} className='border-collapse'>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            {...column.getHeaderProps()}
                                            onClick={() => headerClick(column)}
                                            className="sortable-header"
                                        >
                                            {`${column.render("Header")} ${
                                                sortHeaderValue.id === column.id
                                                    ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                    : ""
                                            }`}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {dataList.length <= 0 &&
                                <tr>
                                    <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                        No data to display
                                    </td>
                                </tr>
                            }
                            {currentItems.map((row) => {
                                prepareRow(row)
                                return (
                                    <tr key={row.original.id}
                                    {...row.getRowProps()} // Attach onClick event handler to the row
                                    >
                                        {row.cells.map((cell) => (
                                            <SetInfo header={cell.render("Cell").props.column.Header} 
                                                _cell={cell}
                                                approveHandleClick={approveHandleClick}
                                                disapproveHandleClick={disapproveHandleClick}
                                                // openImage={openImage}
                                                // isActive={activeRowIds?.includes(row.original.id)}
                                            />
                                        ))}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {rows.length > itemsPerPage ? (
                <div>
                    <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                        <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                                style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                            &lt;&lt;
                        </button>
                        <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                                style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                            <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                        </button>
                        <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                            style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                            NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                        </button>
                        <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                            style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                            &gt;&gt;
                        </button>
                    </div>
                    {`${currentPage}/${totalPages}`}
                </div>
                ) :
                <></>}
            </div>
        </>
    )
}
function SetInfo({header, _cell, approveHandleClick, disapproveHandleClick}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Status") {
        return(
            <>
                <td
                style={{
                    background: value === "Approved" ? "#226d0d" : "",
                    color: value === "Approved" ? "white" : ""
                }}
                >
                {value === "Approved" ? (
                    <>
                    {value}
                    <br />
                    {data.approverFullName ? `${data.approverFullName}` : ""}
                    
                    <br />
                    {data?.approvedDate ? ` (${data?.approvedDate.split("T")[0]})` : ""}
                    </>
                ) : (
                    value
                )}
                </td>
            </>
        )
    }

    if (header === "Location") {
        if (value) {
            const googleMapsUrl = `https://www.google.com/maps?q=${value}`;
            return (
                <>
                    <td>
                        <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                            View Location
                        </a>
                    </td>
                </>
            );
        }
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                    -
                </td>
            );
        }

        time = ConvertForTimeLocal(time, header);

        let timeParts;
        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        const formattedTime = `${hours}:${minutes} ${amPm}`;

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                </td>
            );
        }

        date = ConvertForDateLocal(data.date, header);


        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if (header === "Date Of Registration"
        || header === "Last Logged In"
    ) {
        const value = _cell.render("Cell").props.value;

        if (!value) {
            return <td>-</td>;
        }

        const date = new Date(value);

        if (isNaN(date.getTime())) {
            return <td>-</td>;
        }

        const formattedDateTime = date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });

        return (
            <td>
                {formattedDateTime}
            </td>
        );
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const ConvertForDateLocal = (dateString) => {
    // console.log("dateString", dateString);

    if (!dateString) {
        console.log("Invalid or empty date string");
        return null;
    }

    const dateTimeParts = dateString.split('T');
    if (dateTimeParts.length !== 2) {
        console.log("Invalid date string format");
        return null;
    }

    const datePart = dateTimeParts[0]; // YYYY-MM-DD
    const timePart = dateTimeParts[1]; // HH:MM:SS

    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');

    const date = new Date(
        parseInt(year, 10), 
        parseInt(month, 10) - 1, // JS months are 0-indexed
        parseInt(day, 10), 
        parseInt(hours, 10), 
        parseInt(minutes, 10), 
        parseInt(seconds, 10)
    );

    return date;
};
const ConvertForTimeLocal = (dateString, name) => {
    // console.log("timeString", dateString);

    if (!dateString) {
        console.log(`${name} is empty or invalid data`);
        return "";
    }

    // Split the date and time parts
    const [datePart, timePart] = dateString.split('T');

    if (!timePart) {
        console.log(`${name} does not have a valid time part`);
        return "";
    }

    // Parse the date part
    const [year, month, day] = datePart.split('-');
    
    // Parse the time part
    const [hour, minute, second] = timePart.split(':');
    let hour24 = parseInt(hour, 10);

    // Construct the Date object
    const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minute, 10), parseInt(second, 10));

    // Format the date string in the desired format
    const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

    return formattedDateString;
};
export default MobileHistory
